function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon / danger");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon-/-danger",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#D0021B",
  fillRule: "nonzero",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,0.156862745 C3.67058824,0.156862745 0.156862745,3.67058824 0.156862745,8 C0.156862745,12.3294118 3.67058824,15.8431373 8,15.8431373 C12.3294118,15.8431373 15.8431373,12.3294118 15.8431373,8 C15.8431373,3.67058824 12.3294118,0.156862745 8,0.156862745 Z M8.78431373,11.9215686 L7.21568627,11.9215686 L7.21568627,10.3529412 L8.78431373,10.3529412 L8.78431373,11.9215686 Z M8.78431373,8.78431373 L7.21568627,8.78431373 L7.21568627,4.07843137 L8.78431373,4.07843137 L8.78431373,8.78431373 Z"
})));

var SvgDanger = function SvgDanger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDanger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/danger.7e6def18.svg";
export { ForwardRef as ReactComponent };